"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsHelper = void 0;
var environment_helper_1 = require("./environment.helper");
exports.AnalyticsHelper = {
    SOURCE_DATA_LAYER_CLASS: "source-datalayer",
    stringifyDataLayer: function (newDataLayer) {
        return "json:".concat(JSON.stringify(newDataLayer || {}));
    },
    getDataFromDataLayer: function () {
        var esito = {};
        if (environment_helper_1.EnvironmentHelper.isClientSide()) {
            var dataLayerElements = document.getElementsByClassName("source-datalayer");
            for (var i = 0; i < dataLayerElements.length; i++) {
                var dataLayerElement = dataLayerElements.item(i);
                var dataLayerJson = dataLayerElement === null || dataLayerElement === void 0 ? void 0 : dataLayerElement.getAttribute("data-datalayer");
                if (dataLayerJson && dataLayerJson.includes("json")) {
                    var clearJson = dataLayerJson
                        .replace("json:", "")
                        .replace("&quot;", "");
                    try {
                        var parsedJson = JSON.parse(clearJson);
                        esito = __assign(__assign({}, esito), parsedJson);
                    }
                    catch (e) {
                        console.error("Errore nel parsing di un json da data-datalayer:", e);
                    }
                }
            }
        }
        return esito;
    },
};
